import { Modal } from "antd";
import React from "react";
import useRequest from "../../components/hooks/use-request";
import { CircleLoader } from "react-spinners";
import Icon from "../../assets/icons";
import { showToast } from "../../components/toast";

interface SuspendAdminProps {
  visible: boolean;
  handleClose: () => void;
  id: string;
  isSuspended: boolean;
}

const SuspendAdmin: React.FC<SuspendAdminProps> = ({
  visible,
  handleClose,
  id,
  isSuspended,
}) => {
  const userToken = localStorage.getItem("token");
  const { makeRequest: SuspendAdminById, loading } = useRequest(
    `/admin/${id}/suspend`,
    "PUT",
    {
      Authorization: `Bearer ${userToken}`,
    }
  );

  const handleSuspensionToggle = async () => {
    const [response] = await SuspendAdminById();
    if (response.status) {
      showToast(response.message, true, {
        position: "top-center",
      });
      handleClose();
      // Refresh the page to update the admin list
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    } else {
      showToast(
        response.message || "Something went wrong, please try again",
        false,
        {
          position: "top-center",
        }
      );
    }
  };

  return (
    <Modal
      open={visible}
      onCancel={handleClose}
      footer={null}
      centered
      width={400}
    >
      <div className="text-center">
        <h3 className="text-lg font-semibold text-gray-900 mb-2">
          {isSuspended ? "Unsuspend" : "Suspend"} Admin
        </h3>

        <p className="text-gray-600 mb-6">
          Are you certain you want to {isSuspended ? "unsuspend" : "suspend"}{" "}
          this admin? You can unsuspend them at any time.
        </p>

        <div className="flex gap-3 justify-center">
          <button
            className="bg-gray-300 hover:bg-gray-400 text-gray-700 px-6 py-2 rounded-md font-medium transition-colors duration-200 min-w-[100px]"
            onClick={handleClose}
            disabled={loading}
          >
            Cancel
          </button>
          <button
            className="bg-[#0979A1] hover:bg-[#0979A1] text-white px-6 py-2 rounded-md font-medium transition-colors duration-200 min-w-[100px]"
            onClick={handleSuspensionToggle}
            disabled={loading}
          >
            {loading ? (
              <CircleLoader color="#ffffff" loading={loading} size={16} />
            ) : isSuspended ? (
              "Unsuspend"
            ) : (
              "Suspend"
            )}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default SuspendAdmin;
